

export const materialReportUnitString = {
    ROAD_NUM: 'road_num',
    MATERIAL: 'material',
}

export const materialReportHelper = {
    methods: {
        getSimpleMaterialReport() {
            return {
                id: -1,
                amount: null,
                contract: null,
                work_order: null,
                reporting_date: null,
                material: null,
                unit: null,
                info: null,
                consumption_records: []
            }
        },
        getMaterialReportUnitTranslationString: function (string) {
            switch (string) {
                case materialReportUnitString.ROAD_NUM:
                    return this.$t('contract_reports.unload_records.road_num')
                case materialReportUnitString.MATERIAL:
                    return this.$t('contract_reports.material_name')
            }
        },
    }
}
